import WatchlistRow from "./WatchlistRow";
import { useDispatch, useSelector } from "react-redux";
import {
  setWatchlist,
  addToWatchlist,
  removeFromWatchlist,
  setLoading,
  setError,
} from "../../../redux/watchlistSlice";
import {
  useGetUserWatchlistQuery,
  useAddRemoveSymbolMutation,
} from "../../../redux/exchangeApi";
import { useEffect, useState } from "react";
import AssetModel from "../AssetModel";
import { setSelectedSymbol } from "../../../redux/watchlistSlice";
import { setInitialPrices } from "../../../redux/marketSlice";

const WatchlistPanel = ({ setStepSize }) => {
  const userData = useSelector((state) => state?.user?.userData);
  const prices = useSelector((state) => state.market.prices);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPairId, setSelectedPairId] = useState("");
  const selectedSymbol = useSelector((state) => state.watchlist.selectedSymbol);
  const dispatch = useDispatch();
  const watchlist = useSelector((state) => state.watchlist.items);
  const { data, isLoading, error, refetch } = useGetUserWatchlistQuery(
    userData?.id
  );
  const [toggleSymbol, { isLoading: updatingWatch }] =
    useAddRemoveSymbolMutation();

  // console.log(data, "data user watch list");

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading());
    } else if (error) {
      dispatch(setError());
    } else if (data) {
      const [defaultSelectedSymbol] = data.filter(
        (item) => item.symbol === "BTCUSDT"
      );
      dispatch(
        setSelectedSymbol({
          symbol: defaultSelectedSymbol.symbol,
          segment: defaultSelectedSymbol.platform,
          sellCommission: defaultSelectedSymbol.sell_commission,
          buyCommission: defaultSelectedSymbol.buy_commission,
          commissionType: defaultSelectedSymbol.commission_type,
        })
      );
      dispatch(setWatchlist(data)); // only keep symbols
      dispatch(setInitialPrices(data));
    }
  }, [data, isLoading, error, dispatch]);

  const handleToggleSymbol = async (symbol, action, segment) => {
    setSelectedPairId(symbol);
    const result = await toggleSymbol({
      segment,
      brokerId: userData?.refred_by_id,
      symbol,
      action: action,
    });

    if (result?.data?.status && action === "add") {
      refetch();
      dispatch(addToWatchlist(symbol));
      setSelectedPairId("");
    } else {
      refetch();
      dispatch(removeFromWatchlist(symbol));
      setSelectedPairId("");
      const [defaultSelectedSymbol] = data.filter(
        (item) => item.symbol === "BTCUSDT"
      );
      dispatch(
        setSelectedSymbol({
          symbol: defaultSelectedSymbol.symbol,
          segment: defaultSelectedSymbol.platform,
          sellCommission: defaultSelectedSymbol.sell_commission,
          buyCommission: defaultSelectedSymbol.buy_commission,
          commissionType: defaultSelectedSymbol.commission_type,
        })
      );
    }
  };

  // Group watchlist items
  const groupedWatchlist = {
    Stocks: watchlist.filter(
      (item) => item.platform === "equity" || item.platform === "stock"
    ),
    Forex: watchlist.filter((item) => item.platform === "forex"),
    Crypto: watchlist.filter((item) => item.platform === "crypto"),
  };

  const renderWatchlistRows = (categoryItems) =>
    categoryItems.map((item) => {
      const priceData = prices[item.symbol] || {};
      return (
        <WatchlistRow
          setStepSize={setStepSize}
          stepSize={item.stepSize}
          key={item.symbol}
          active={selectedSymbol === item.symbol}
          symbol={item.symbol}
          bid={priceData.bid || item.best_bid || 0}
          ask={priceData.ask || item.best_ask || 0}
          isDefault={item.is_default === "Y"}
          icon={item.icon}
          change={priceData.changePer || 0}
          removeWatchListSymbol={handleToggleSymbol}
          segment={item.platform}
          isUpdating={updatingWatch}
          sellCommission={item.sell_commission}
          buyCommission={item.buy_commission}
          commissionType={item.commission_type}
        />
      );
    });

  return (
    <div className="dash-grid-two">
      <div className="ne_box bg2 h_100 border_box d_new_right">
        <div className="panel-heading tab-box p-2 d-flex">
          <h6 className="text-left drag-handle mr-auto">Watchlist</h6>
          <i
            className="bi bi-plus-lg cursor-pointer"
            onClick={() => setIsModalOpen(true)}
            style={{ fontSize: "18px" }}
          />
        </div>

        <table className="table table-hover currency_table2">
          <thead>
            <tr>
              <th>Symbol</th>
              <th className="text-right">Best BID</th>
              <th className="text-right">Best ASK</th>
              <th className="text-right">Chg%</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(groupedWatchlist).map(([category, items]) => (
              <>
                {items.length > 0 && (
                  <tr key={category}>
                    <td
                      colSpan="4"
                      className="font-weight-bold text-uppercase text-muted"
                    >
                      {category}
                    </td>
                  </tr>
                )}
                {renderWatchlistRows(items)}
              </>
            ))}
          </tbody>
        </table>
      </div>
      <AssetModel
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        segment="crypto"
        added={watchlist.map((item) => item.symbol)}
        getSymbol={refetch}
        updateUserWatchList={handleToggleSymbol}
        selectedPairId={selectedPairId}
        updatingWatch={updatingWatch}
      />
    </div>
  );
};

export default WatchlistPanel;
